import {createAction, createReducer, getType} from "typesafe-actions"

import { SpeedAndAmplitudeStateType } from "../../../../models";

export const InitialSpeedAndAmplitudeState = {
    mmPerMv: 10,
    mmPerSecond: 25
};

export const setMMPerSecond = createAction("setMMPerSecond")<number>();
export const setMMPerMv = createAction("setMMPerMv")<number>();

export const SpeedAndAmplitudeReducer = createReducer<SpeedAndAmplitudeStateType>(InitialSpeedAndAmplitudeState, {
    [getType(setMMPerSecond)]: (state, action?: any) => ({
        ...state,
        mmPerSecond: action.payload
    }),
    [getType(setMMPerMv)]: (state, action?: any) => ({
        ...state,
        mmPerMv: action.payload
    }),
});

export default SpeedAndAmplitudeReducer
